import {
  Dialog,
  DialogBackdrop,
  DialogPanel,
  Disclosure,
  DisclosureButton,
  DisclosurePanel,
  TransitionChild
} from '@headlessui/react';
import {
  BanknotesIcon,
  CalendarDaysIcon,
  ChartPieIcon,
  Cog6ToothIcon,
  CreditCardIcon,
  CubeIcon,
  FolderIcon,
  HomeIcon,
  NewspaperIcon,
  ShoppingCartIcon,
  Squares2X2Icon,
  UserCircleIcon,
  UserGroupIcon,
  UserIcon,
  XMarkIcon
} from '@heroicons/react/24/outline';
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";

import { useLocalStorage } from "../../hooks";
import { userState } from "../../redux/reducers/userReducer";


import logo_w from "../../assets/logo-w.svg";
import { classNames, onContactClick } from "../../helpers";
import * as dashboardActions from "../../redux/reducers/dashboardReducer";
// import menu_home from "../../assets/menu_home.svg";
import menu_schedule from "../../assets/menu_schedule.svg";
import menu_event from "../../assets/menu_event.svg";
import menu_setting from "../../assets/menu_setting.svg";
import menu_location from "../../assets/menu_location.svg";
import { ChevronRightIcon } from '@heroicons/react/20/solid';
import { useTenant } from '../../provider/TenantProvider';
import fitclubAppIcon from "../../assets/fitclub-app-icon.png";
import MaskIcon, { MEMBER_ICONS } from "./MaskIcon";

export default function TwSidebar(props) {
  const {
    children,
    sidebarOpen,
    setSidebarOpen,
    logout,
  } = props
  const location = useLocation();
  const dispatch = useDispatch();
  const [userToken, setUserToken] = useLocalStorage("userToken");
  const userReduxState = useSelector(userState);
  const navigate = useNavigate();

  return (
    <div>
      <Dialog open={sidebarOpen} onClose={setSidebarOpen} className="relative z-50 lg:hidden">
        <DialogBackdrop
          transition
          className="fixed inset-0 bg-gray-900/80 transition-opacity duration-300 ease-linear data-closed:opacity-0"
        />

        <div className="fixed inset-0 flex">
          <DialogPanel
            transition
            className="relative mr-16 flex w-full max-w-xs flex-1 transform transition duration-300 ease-in-out data-closed:-translate-x-full"
          >
            <TransitionChild>
              <div className="absolute top-0 left-full flex w-16 justify-center pt-5 duration-300 ease-in-out data-closed:opacity-0">
                <button type="button" onClick={() => setSidebarOpen(false)} className="-m-2.5 p-2.5">
                  <span className="sr-only">Close sidebar</span>
                  <XMarkIcon aria-hidden="true" className="size-6 text-white" />
                </button>
              </div>
            </TransitionChild>
            {/* Sidebar component, swap this element with another sidebar if you like */}
            <TwSidebarMenue
              {...props}
            />
          </DialogPanel>
        </div>
      </Dialog>

      {/* Static sidebar for desktop */}
      <div className="hidden lg:fixed lg:inset-y-0 lg:z-50 lg:flex lg:w-64 lg:flex-col">
        {/* Sidebar component, swap this element with another sidebar if you like */}
        <TwSidebarMenue
          {...props}
        />
      </div>
    </div>

  );
}


export function TwSidebarMenue({
  children,
  sidebarOpen,
  setSidebarOpen,
  logout,
}) {
  const { tenant, tenantData, tenantLoading } = useTenant();
  const location = useLocation();
  const dispatch = useDispatch();
  const [userToken, setUserToken] = useLocalStorage("userToken");
  const userReduxState = useSelector(userState);
  const navigate = useNavigate();
  const [menuList, setMenuList] = React.useState([]);
  const [settingMenuList, setSettingMenuList] = React.useState([]);

  // Order follows daily use (Schedule, Members) then setup items (Classes, Products). The Setup guide in the header walks new clubs through setup order.
  const classList = [
    {
      id: 2,
      label: "My Schedule",
      // icon: CalendarDaysIcon,
      img: menu_schedule,
      navigate: { to: "/myclasses/myschedule", state: { title: "Schedule List" } },
      current: false,
    },
    {
      id: 4,
      label: "My Members",
      icon: UserGroupIcon,
      navigate: { to: "/mymembers", state: { title: "Members List" } },
      current: false,
    },
    {
      id: 3,
      label: "My Classes",
      // icon: FolderIcon,
      img: menu_event,
      navigate: { to: "/myclasses", state: { title: "Class List" } },
      current: false,
    },
    {
      id: 6,
      label: "My Products",
      icon: CubeIcon,
      navigate: { to: "/products", state: { title: "My Products" } },
      current: false,
    },
    // Website & webshop: Settings › Widgets since 2026-11-05 (/my-account/widgets)
    {
      id: 5,
      label: "News Feeds",
      icon: NewspaperIcon,
      navigate: { to: "/newsfeed", state: { title: "News Feeds List" } },
      current: false,
    },
    // My Locations: clubs pick, add and rename locations in My Schedule (Add sessions / Change location). The page stays for events.
    // {
    //   id: 7,
    //   label: "My Locations",
    //   icon: MapPinIcon,
    //   navigate: { to: "/mylocation", state: { title: "My Locations" } },
    //   current: false,
    // },
    // Club Stats now lives on the Dashboard (tiles open Members / Bookings / Revenue insights); /my-stats redirects there.
    // {
    //   id: 8,
    //   label: "Club Stats",
    //   icon: ChartPieIcon,
    //   navigate: { to: "/my-stats", state: { title: "Club Stats" } },
    //   current: false,
    // },
  ];
  // Old event / service menus (My Events, My Services, My Venues, My Team) removed 2026-11-02: clubs only use classes.
  const settingList = [
    {
      label: "Account Settings",
      icon: Cog6ToothIcon,
      navigate: { to: "/my-account" },
      current: false,
    },
    // {
    //   label: "My Profile",
    //   icon: UserCircleIcon,
    //   navigate: { to: "/myprofile" },
    //   current: false,
    // },
    // {
    //   label: "Business Profile",
    //   icon: BuildingStorefrontIcon,
    //   navigate: { to: "/businessprofile/view" },
    //   current: false,
    // },
    // {
    //   label: "Payment Profile",
    //   icon: BanknotesIcon,
    //   navigate: { to: "/payment/profile" },
    //   current: false,
    // },
    // {
    //   label: "My Subscription",
    //   icon: CreditCardIcon,
    //   navigate: {
    //     to: "/my-subscription", state: {
    //       origin: "upgradeSubscription",
    //     }
    //   },
    //   current: false,
    // },
    // Logout now sits at the bottom of the sidebar, under Get Support.
  ];
  // Clubs (class/event): Account settings is a direct menu item instead of a Settings submenu.
  const accountSettingsItem = {
    id: 5,
    label: "Settings",
    icon: Cog6ToothIcon,
    navigate: { to: "/my-account" },
    current: false,
  };
  const isCurrentPath = (to) => !!to && (window.location.pathname === to || (to === "/my-account" && window.location.pathname.startsWith("/my-account/")));
  const list = [
    {
      label: 'Dashboard',
      navigate: { to: "/home/dashboard", state: null },
      icon: Squares2X2Icon,
      // img: menu_home,
      current: true
    },
    {
      id: 5,
      label: "Settings",
      icon: Cog6ToothIcon,
      current: false,
      subMenu: settingList,
    },
  ];

  // Members (iOS app icons): the club first (Club Schedule, Club Webshop, Contact the club),
  // then, after a divider, their own pages (My Profile, My Purchases, My Bookings).
  const studentlist = [
    {
      id: 2,
      label: "Club Schedule",
      maskIcon: MEMBER_ICONS.clubSchedule,
      navigate: { to: "/members/schedule", state: { title: "Club Schedule" } },
      current: false,
    },
    {
      id: 3,
      label: "Club Webshop",
      maskIcon: MEMBER_ICONS.clubWebshop,
      navigate: { to: "/members/webshop", state: { title: "Club Webshop" } },
      current: false,
    },
    {
      id: 6,
      label: "Contact the club",
      maskIcon: MEMBER_ICONS.contactClub,
      contactClub: true, // WhatsApp / email the club; hidden when the club has neither
      current: false,
    },
    {
      id: 1,
      label: "My Profile",
      maskIcon: MEMBER_ICONS.myProfile,
      navigate: { to: "/members/my-profile", state: null },
      dividerBefore: true,
      current: false,
    },
    {
      id: 4,
      label: "My Purchases",
      maskIcon: MEMBER_ICONS.myPurchases,
      navigate: { to: "/members/purchases", state: null },
      current: false,
    },
    {
      id: 5,
      label: "My Bookings",
      maskIcon: MEMBER_ICONS.myBookings,
      navigate: { to: "/members/bookings", state: null },
      current: false,
    },
  ];


  React.useEffect(() => {
    /* if ((userToken === undefined || userToken == "")) {
      // navigation("/home/dashboard");
      window.location.href = "/";
    } */
    let addmenu = [];
    if (userReduxState.userData?.userType == "student") {
      let finelMenu = [...studentlist]
      let i = 1;
      addmenu.length && addmenu.map((data) => {
        finelMenu.splice(i++, 0, data)
        return data;
      });
      setMenuList(finelMenu.map((e) => ({ ...e, current: !!e?.navigate?.to && (window.location.pathname === e.navigate.to || window.location.pathname.startsWith(e.navigate.to + "/")) })));
      return;
    }

    if (userReduxState.businessType === "class") {
      addmenu = classList;
    }
    let finelMenu = [list[0], accountSettingsItem]
    let i = 1;
    addmenu.length && addmenu.map((data) => {
      finelMenu.splice(i++, 0, data)
      return data;
    });

    setMenuList(finelMenu.map((e) => ({ ...e, current: isCurrentPath(e?.navigate?.to) })));
    let finelSettingList = [...settingList]
    if (userReduxState.businessType === "service") {
      finelSettingList.splice(1, 0, ...[/* {
        label: "My Available Time",
        navigate: { to: "/my-available-time" },
      }, */{
          label: "My Connected Apps",
          icon: Cog6ToothIcon,
          navigate: { to: "/my-connected-apps" },
          current: false,
        }, {
          label: "Online booking",
          icon: Cog6ToothIcon,
          navigate: { to: "/manage-online-booking" },
          current: false,
        }, /* {
          label: "My Subscription",
          icon: Cog6ToothIcon,
          navigate: { to: "/my-subscription", state: {
            origin: "upgradeSubscription",
          } },
          current: false,
        } */])
    }
    // setSettingMenuList(finelSettingList.map((e) => ({ ...e, current: (e?.navigate?.to && window.location.pathname === e.navigate.to) ? true : false })))
  }, []);


  const mainMenuClick = (item) => {
    if (item.contactClub) {
      if (clubContact) clubContact();
      return;
    }
    if (item.subMenu) {
      console.log("subMenu");
      /** no click **/
    } else if (item.navigate) {
      document.body.style.overflowY = ''
      document.body.scrollTop = document.documentElement.scrollTop = 0;
      if (location.pathname !== item.navigate.to) {
        if (item.navigate.to === "/home/dashboard") {
          dispatch(dashboardActions.setCalendarSessionId(-1));
        } else if (item.navigate?.target && item.navigate.target === "newwindows") {
          window.open(item.navigate.to);
          return;
        }
        navigate(item.navigate.to, { state: item.navigate.state, ...item.navigate });
      }
    } else if (item.label.toLowerCase() === "logout") {
      return logout();
    }
  };

  const settingMenuClick = (item) => {
    console.log("item.label", item.label);
    if (item.label === "Logout") {
      return logout();
    }
    navigate(item.navigate.to, {
      state: item.navigate.state,
    });
  };

  // Members contact their own club (WhatsApp to the club's contact number, else email), not FitClub support.
  const isStudent = userReduxState.userData?.userType === "student";
  const clubProfile = tenantData?.business_details?.business_detail || {};
  const clubWhatsApp = String(clubProfile.workNumber || "").replace(/[^\d]/g, "");
  const clubEmail = String(clubProfile.workEmail || "").trim();
  const clubContact = clubWhatsApp
    ? () => window.open(`https://wa.me/${clubWhatsApp}`, "_blank", "noopener")
    : clubEmail
      ? () => window.open(`mailto:${clubEmail}`, "_self")
      : null;

  return (
    <div className="flex grow flex-col gap-y-5 overflow-y-auto bg-brown-coffee px-6 pb-4">
      <div className="flex min-h-[4rem] shrink-0 items-center justify-start border-b border-[#ffffff40] py-3">
        {userReduxState.userData?.userType == "teacher" ? (
          <ClubHeader logo={userReduxState.userData?.myBusinessProfile?.logo} name={userReduxState.userData?.myBusinessProfile?.businessName} />
        ) : (tenantLoading == false && (tenantData.businessName && tenantData.logo && tenantData.businessName != "DEFAULT" && tenantData.businessName != "NOTFOUND") ? (
          <ClubHeader logo={tenantData.logo} name={tenantData.businessName} />
        ) : (<img
          alt="Bookzy"
          src={logo_w}
          className="h-8 w-auto"
        />))}
      </div>
      <nav className="flex flex-1 flex-col">
        <ul className="flex flex-1 flex-col gap-y-7">
          <li className="mt-[20%]">
            <ul className="-mx-2 space-y-1">
              {menuList.filter((item) => !item.contactClub || clubContact).map((item) => (
                <React.Fragment key={item.label}>
                {item.dividerBefore && <li aria-hidden="true" className="!my-4 border-t border-[#ffffff2e]" />}
                <li data-tour={item?.navigate?.to || undefined}>
                  {!item.subMenu ? (<button
                    type="button"
                    onClick={() => { mainMenuClick(item) }}
                    className={classNames(
                      item.current
                        ? 'bg-white text-brown-coffee shadow-sm'
                        : 'text-gray-200 hover:bg-light-brown-coffee hover:text-white',
                      'group w-full flex items-center gap-x-4 rounded-xl p-2 py-3 text-lg 1sm:text-base font-semibold',
                    )}
                  >
                    {item.maskIcon && (<MaskIcon
                      src={item.maskIcon}
                      className={classNames(
                        item.current ? 'text-brown-coffee' : 'text-gray-200 group-hover:text-white',
                        'size-6',
                      )}
                    />)}
                    {item.icon && (<item.icon
                      aria-hidden="true"
                      className={classNames(
                        item.current ? 'text-brown-coffee' : 'text-gray-200 group-hover:text-white',
                        'size-6 shrink-0',
                      )}
                    />)}
                    {item.img && (<MaskIcon
                      src={item.img}
                      className={classNames(
                        item.current ? 'text-brown-coffee' : 'text-gray-200 group-hover:text-white',
                        'size-6',
                      )}
                    />)}
                    {item.label}
                  </button>) : (
                    <Disclosure as="div">
                      <DisclosureButton
                        className={classNames(
                          item.current
                            ? 'bg-white text-brown-coffee shadow-sm'
                            : 'text-gray-200 hover:bg-light-brown-coffee hover:text-white',
                          'group flex w-full items-center gap-x-4 rounded-xl p-2 py-3 text-left text-lg 1sm:text-base font-semibold',
                        )}
                      >
                        {/* <item.icon aria-hidden="true" className="size-6 shrink-0 text-gray-400" /> */}
                        {item.icon && (<item.icon
                          aria-hidden="true"
                          className={classNames(
                            item.current ? 'text-brown-coffee' : 'text-gray-200 group-hover:text-white',
                            'size-6 shrink-0',
                          )}
                        />)}
                        {item.img && (<MaskIcon
                      src={item.img}
                      className={classNames(
                        item.current ? 'text-brown-coffee' : 'text-gray-200 group-hover:text-white',
                        'size-6',
                      )}
                    />)}
                        {item.label}
                        <ChevronRightIcon
                          aria-hidden="true"
                          className="ml-auto size-5 shrink-0 text-gray-200 group-data-[open]:rotate-90 group-data-[open]:text-white"
                        />
                      </DisclosureButton>
                      <DisclosurePanel as="ul" className="mt-1 px-2">
                        {item.subMenu.map((subItem) => (
                          <li key={subItem.label}>
                            <DisclosureButton
                              as="button"
                              onClick={() => { mainMenuClick(subItem) }}
                              className={classNames(
                                subItem.current ? 'bg-white text-brown-coffee shadow-sm'
                                  : 'text-gray-200 hover:bg-light-brown-coffee hover:text-white',
                                'group flex w-full items-center gap-x-3 rounded-xl py-2 pl-5 pr-2 text-left text-sm/8',
                              )}
                            >
                              {subItem.icon && (<subItem.icon
                                aria-hidden="true"
                                className={classNames(
                                  subItem.current ? 'text-brown-coffee' : 'text-gray-200 group-hover:text-white',
                                  'size-5 shrink-0',
                                )}
                              />)}
                              {subItem.img && (<MaskIcon
                      src={subItem.img}
                      className={classNames(
                        subItem.current ? 'text-brown-coffee' : 'text-gray-200 group-hover:text-white',
                        'size-5',
                      )}
                    />)}
                              {subItem.label}
                            </DisclosureButton>
                          </li>
                        ))}
                      </DisclosurePanel>
                    </Disclosure>
                  )}
                </li>
                </React.Fragment>
              ))}
            </ul>
          </li>
          {settingMenuList.length > 0 && (<li>
            <div className="text-xs/6 font-semibold text-gray-200">Settings</div>
            <ul className="-mx-2 mt-2 space-y-1">
              {settingMenuList.map((item) => (
                <li key={item.label}>
                  <button
                    onClick={() => { settingMenuClick(item) }}
                    className={classNames(
                      item.current
                        ? 'bg-white text-brown-coffee shadow-sm'
                        : 'text-gray-200 hover:bg-light-brown-coffee hover:text-white',
                      'group w-full flex gap-x-3 rounded-xl p-2 text-lg font-semibold',
                    )}
                  >
                    <item.icon
                      aria-hidden="true"
                      className={classNames(
                        item.current ? 'text-brown-coffee' : 'text-gray-200 group-hover:text-white',
                        'size-6 shrink-0',
                      )}
                    />
                    <span className="truncate">{item.label}</span>
                  </button>
                </li>
              ))}
            </ul>
          </li>)}
          <li className="mt-auto -mx-2 flex flex-col gap-1 border-t border-[#ffffff2e] pt-4">
            {!isStudent && (<button
              type="button"
              onClick={onContactClick}
              className="group flex w-full items-center gap-x-3 rounded-xl p-2 text-left text-sm/6 font-semibold text-gray-200 hover:bg-light-brown-coffee hover:text-white"
            >
              <svg className="size-6 shrink-0" width="26" height="26" viewBox="0 0 25 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M1.3521 12.888C1.35154 15.0798 1.88615 17.2199 2.90272 19.1062L1.25488 25.5511L7.41203 23.8217C9.11502 24.8148 11.0231 25.3352 12.9621 25.3353H12.9672C19.3681 25.3353 24.5787 19.7558 24.5814 12.8978C24.5826 9.57468 23.3756 6.44979 21.1826 4.0988C18.9899 1.748 16.0738 0.452689 12.9667 0.451172C6.56499 0.451172 1.35484 6.03039 1.3522 12.888" fill="url(#paint0_linear_2466_6098)" />
                <path d="M1.3521 12.888C1.35154 15.0798 1.88615 17.2199 2.90272 19.1062L1.25488 25.5511L7.41203 23.8217C9.11502 24.8148 11.0231 25.3352 12.9621 25.3353H12.9672C19.3681 25.3353 24.5787 19.7558 24.5814 12.8978C24.5826 9.57468 23.3756 6.44979 21.1826 4.0988C18.9899 1.748 16.0738 0.452689 12.9667 0.451172C6.56499 0.451172 1.35484 6.03039 1.3522 12.888" fill="url(#paint1_linear_2466_6098)" />
                <path d="M0.93791 12.883C0.937249 15.1536 1.49103 17.3702 2.54384 19.324L0.836914 26L7.21484 24.2086C8.97216 25.235 10.9507 25.7761 12.964 25.777H12.9692C19.5998 25.777 24.9975 19.9967 25.0004 12.8933C25.0015 9.4507 23.751 6.21348 21.4797 3.77826C19.208 1.34334 16.1876 0.00141553 12.9692 0C6.3375 0 0.940553 5.77942 0.93791 12.883ZM4.7361 18.9876L4.49796 18.5826C3.49688 16.8775 2.96849 14.9071 2.96924 12.8838C2.97142 6.97949 7.45713 2.17588 12.973 2.17588C15.6442 2.17709 18.1546 3.29253 20.0427 5.31634C21.9308 7.34035 22.9697 10.0309 22.969 12.8925C22.9666 18.7968 18.4808 23.601 12.9692 23.601H12.9653C11.1707 23.6 9.4106 23.0837 7.87565 22.1081L7.51037 21.876L3.72558 22.939L4.7361 18.9875V18.9876Z" fill="url(#paint2_linear_2466_6098)" />
                <path d="M9.96179 7.49749C9.73658 6.96131 9.49957 6.95049 9.28541 6.94109C9.11003 6.933 8.90955 6.9336 8.70926 6.9336C8.50878 6.9336 8.18304 7.01439 7.90771 7.33642C7.6321 7.65876 6.85547 8.43771 6.85547 10.022C6.85547 11.6064 7.93272 13.1375 8.0829 13.3525C8.23326 13.5672 10.1626 16.9224 13.2181 18.2132C15.7575 19.2858 16.2743 19.0725 16.8254 19.0187C17.3767 18.9651 18.6041 18.24 18.8545 17.488C19.1051 16.7362 19.1051 16.0917 19.03 15.957C18.9548 15.8228 18.7544 15.7423 18.4537 15.5813C18.153 15.4202 16.6751 14.6412 16.3996 14.5337C16.1239 14.4263 15.9236 14.3727 15.7231 14.6952C15.5226 15.0171 14.9469 15.7423 14.7715 15.957C14.5962 16.1723 14.4207 16.1991 14.1202 16.038C13.8194 15.8764 12.8512 15.5368 11.7026 14.4399C10.8089 13.5863 10.2056 12.5322 10.0302 12.2098C9.85485 11.8879 10.0114 11.7134 10.1622 11.5529C10.2973 11.4086 10.4629 11.1769 10.6134 10.9889C10.7632 10.8008 10.8133 10.6667 10.9135 10.4519C11.0138 10.237 10.9636 10.0489 10.8886 9.88782C10.8133 9.72675 10.2291 8.13418 9.96179 7.49749Z" fill="white" />
                <defs>
                  <linearGradient id="paint0_linear_2466_6098" x1="1167.58" y1="2510.44" x2="1167.58" y2="0.451172" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#1FAF38" />
                    <stop offset="1" stopColor="#60D669" />
                  </linearGradient>
                  <linearGradient id="paint1_linear_2466_6098" x1="1167.58" y1="2510.44" x2="1167.58" y2="0.451172" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#1FAF38" />
                    <stop offset="1" stopColor="#60D669" />
                  </linearGradient>
                  <linearGradient id="paint2_linear_2466_6098" x1="1209.01" y1="2600" x2="1209.01" y2="0" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#F9F9F9" />
                    <stop offset="1" stopColor="white" />
                  </linearGradient>
                </defs>
              </svg>
              {isStudent ? "Contact the club" : "Get Support"}
            </button>)}
            {(
              <button
                type="button"
                onClick={() => logout()}
                className="group flex w-full items-center gap-x-3 rounded-xl p-2 text-left text-sm/6 font-semibold text-gray-200 hover:bg-light-brown-coffee hover:text-white"
              >
                {/* Same logout icon as the FitClub app (iOS icon-logout), for members and clubs */}
                <MaskIcon src={MEMBER_ICONS.logout} className="size-6 text-gray-200 group-hover:text-white" />
                Log out
              </button>
            )}
            {isStudent && (
              <div className="flex items-center gap-2 px-2 pt-2 text-xs font-bold text-white/70">
                Powered by
                <img src={fitclubAppIcon} alt="" className="h-[18px] w-[18px] rounded-[22%]" />
                <span className="font-extrabold text-white">FitClub</span>
              </div>
            )}
          </li>
        </ul>
      </nav>
    </div>
  );
}

/** Club logo + name at the top of the sidebar: left aligned; a long name wraps to two lines, then ends with "…". */
function ClubHeader({ logo, name }) {
  return (
    <div className="flex w-full min-w-0 items-center gap-3 text-white" title={name || ""}>
      <ClubLogo src={logo} name={name} />
      <span className="min-w-0 flex-1 break-words text-base font-bold leading-snug line-clamp-2">{name}</span>
    </div>
  );
}

/** Club logo in the sidebar (fixed square so long names get the room); falls back to the club's initials when there is no logo or it fails to load. */
function ClubLogo({ src, name }) {
  const [failed, setFailed] = React.useState(false);
  React.useEffect(() => setFailed(false), [src]);
  const url = typeof src === "string" ? src.trim() : "";
  if (url && !failed) {
    return (
      <span className="flex h-11 w-11 shrink-0 items-center justify-center overflow-hidden rounded-xl bg-white">
        <img alt="" src={url} onError={() => setFailed(true)} className="h-full w-full object-contain" />
      </span>
    );
  }
  const initials =
    String(name || "")
      .split(/\s+/)
      .filter(Boolean)
      .slice(0, 2)
      .map((w) => w[0].toUpperCase())
      .join("") || "FC";
  return (
    <span aria-hidden="true" className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-portland-orange text-base font-black text-white">
      {initials}
    </span>
  );
}
